const getIsViewButtonDisabled = extension => {
  return extension == null;
};
export default getIsViewButtonDisabled;